import { render, staticRenderFns } from "./dialog-newsstorage.vue?vue&type=template&id=cc5b08ec&"
import script from "./dialog-newsstorage.vue?vue&type=script&lang=js&"
export * from "./dialog-newsstorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports